import { SSE as SSEClass } from "martti-agent-services"
import { dataService } from "./dataService"
import { config } from "./configService"
import { logger } from "./logger"
import { authService } from "./authService"

export const SSE = new SSEClass({ config, logger, dataService, authService })
